export const AUTH_BEARER_TOKEN_COOKIE_NAME = 'access_token'
export const BUSINESS_TRAVELLER_AUTH_COOKIE_HOSTNAME = 'lebusinesstraveller.com'
export const BUSINESS_TRAVELLER_AUTH_COOKIE_DOMAIN = `.${BUSINESS_TRAVELLER_AUTH_COOKIE_HOSTNAME}`

export function isBusinessTravellerHostname(hostname: string): boolean {
  return hostname === BUSINESS_TRAVELLER_AUTH_COOKIE_HOSTNAME || hostname.endsWith(`.${BUSINESS_TRAVELLER_AUTH_COOKIE_HOSTNAME}`)
}
